export const getWorkingGroupApi = (params = {}, query = {}) => {
    const { leaseSlug } = params;
    const queryString = new URLSearchParams(query).toString();
    return `lease/${leaseSlug}/working_groups${queryString ? `?${queryString}` : ''}`;
};
// member api used for sorting
export const getWorkingGroupMemberApi = (params = {}, query = {}) => {
    const { leaseSlug } = params;
    const queryString = new URLSearchParams(query).toString();
    return `lease/${leaseSlug}/working_groups/${params?.wrkSlug}/members${queryString ? `?${queryString}` : ''}`;
};

export const addWorkingApi = (params) => {
    return `lease/${params?.leaseSlug}/working_groups`;
};

export const updateWorkingApi = (params) => {
    return `lease/${params?.leaseSlug}/working_groups/${params?.slug}`;
};

export const deleteWorkingGroupApi = (params) => {
    return `lease/${params?.leaseSlug}/working_groups`;
};

export const getWorkingGroupMembersApi = (params = {}, query = {}, wrkSlug) => {
    const { leaseSlug } = params;
    const queryString = new URLSearchParams(query).toString();
    return `lease/${leaseSlug}/working_groups/${wrkSlug}/members${queryString ? `?${queryString}` : ''}`;
};
export const addMembersApi = (params) => {
    return `lease/${params?.leaseSlug}/working_groups/${params?.wrkGrpSlug}/members`;
};

export const updatemembersApi = (params) => {
    return `lease/${params?.leaseSlug}/working_groups/${params?.wrkGrpSlug}/members/${params?.memberSlug}`;
};
export const deleteMembersApi = (params) => {
    return `lease/${params?.leaseSlug}/working_groups/${params?.wrkGrpSlug}/members`;
};
// Working Group File Upload Api
export const fileUploadPostApi = (wrkgSlug) => {
    return `lease/working_group/${wrkgSlug}/attachments`;
};

// Working Group Members File Upload Api
export const fileUploadMemberPostApi = (memberslug) => {
    return `/lease/working_group_member/${memberslug}/attachments`;
};

export const workingGroupfileUploadPostApi = (workingGroup_slug) => {
    return `/get-pre-signed-url/working_group/${workingGroup_slug}`;
};

export const workingGroupAttachmentMetaData=(attachments_slug)=>{
    return `update-attachment-metadata/working_group/${attachments_slug}`
}

export const workingGroupMemberfileUploadPostApi = (working_group_member_slug) => {
    return `/get-pre-signed-url/working_group_member/${working_group_member_slug}`;
};

export const workingGroupMemberAttachmentMetaData=(attachments_slug)=>{
    return `update-attachment-metadata/working_group_member/${attachments_slug}`
}
